<div
  class="c-validation-message qa-validation-message"
  role="alert"
  [attr.id]="id"
>{{ validationMessage }}</div>
